/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const paginatedCandidateExportLogsDataSchema = z.object({
	data: z.array(
		z.object({
			id: z.string(),
			exportIntegrationId: z.string(),
			formSubmissionId: z.string(),
			campaignId: z.string(),
			externalCandidateId: z.string().nullable(),
			externalApplicationId: z.string().nullable(),
			status: z.union([z.literal('completed'), z.literal('failed')]),
			createdAt: z.iso.datetime(),
			updatedAt: z.iso.datetime(),
		}),
	),
	meta: z.object({ currentPage: z.number(), lastPage: z.number(), perPage: z.number(), total: z.number() }),
})

export type PaginatedCandidateExportLogsDataSchema = z.infer<typeof paginatedCandidateExportLogsDataSchema>
